<template>
  <div id="app" v-wheel="onWheel">
    <Header />
    <Navigation />
    <div class="container">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from 'vue'
import vuewheel from 'vuewheel'
import Header from '@/components/Header'
import Navigation from '@/components/Navigation'
import Footer from "@/components/TheFooter"
import {mapMutations} from "vuex";

Vue.use(vuewheel)

export default {
  data(){
    return {
      routes: this.$router.options.routes
    };
  },
  components: {
      Header,
      Navigation,
      Footer
  },
  methods: {
    onWheel(e){
      if(this.$store.state.isMovePage)return;
      let num, currentRoute, nextRoute;
      currentRoute = this.$router.currentRoute.name ? this.$router.currentRoute.name :'home';
      for(let i = 0; i < this.routes.length - 1; i++){
        if(this.routes[i].name===currentRoute)
        {
          num = i;
          break;
        }
      }
      if(e.deltaY > 0) num++;
      if(e.deltaY <= 0) num--;
      if(num < 0 || num >= this.routes.length-1)return;
      nextRoute = this.routes[num].name;
      if(nextRoute == 'home')nextRoute = '/';
      this.$router.push(nextRoute);
    }
  }
}
</script>